const formMessage = ($ => {
    /**
     * Cria a estrutura necessária para gerar uma mensagem de sucesso ou erro a ser exibida
     * em um formulário processado via AJAX
     * @param {*} responseResult     Dados da resposta da requisição
     * @returns {JQueryElement}
     */
    const divMsg = $("<div></div>");

    function createFormMessage(responseResult)
    {
        divMsg.addClass("msg-success").text(responseResult.message);

        if (responseResult.status === "success") {
            divMsg.removeClass("msg-error").addClass("msg-success");
        } else {
            divMsg.removeClass("msg-success").addClass("msg-error");
        }

        setTimeout(() => {
            divMsg.remove();
        }, 5000);

        return divMsg;
    }

    return {
        createFormMessage
    }
})(jQuery);
